import { RouterProvider, createBrowserRouter } from "react-router-dom";

//import EditEventPage from "./pages/EditEvent";
import ErrorPage from "./pages/Error";
// import EventDetailPage, {
//   loader as eventDetailLoader,
//   action as deleteEventAction,
// } from "./pages/EventDetail";
//import EventsPage, { loader as eventsLoader } from "./pages/Events";
//import EventsRootLayout from "./pages/EventsRoot";
import HomePage from "./pages/Home";
//import NewEventPage from "./pages/NewEvent";
import RootLayout, { loader as tokenLoader } from "./pages/Root";

import AuthForm, { action as authAction } from "./components/AuthForm";
import SignupForm, { action as signupAction } from "./components/SignupForm";
import { action as logoutAction } from "./pages/Logout";
import { checkAuthLoader } from "./util/auth";
import QuestionDetail from "./pages/QuestionDetail";
// acutal page imports for feedback app

import FeedbackForm1 from "./components/FeedbackFormComponent1";

import SubmitSuccess from "./pages/SubmitSucces";
import FeedbackQRCode from "./pages/FeedbackQRCode";
import MyProfilePage, { action as profileAction } from "./pages/MyProfilePage";
import AiSummary from "./pages/AiSummary";
import SubmitSuccessLink from "./pages/SubmitSuccessLink";
import SavedFeedbacks from "./pages/SavedFeedbacks";
import StaffPage from "./pages/StaffPage";
import LoyaltyPage from "./pages/LoyaltyPage";
import LoyaltyTrackerPage from "./pages/LoyaltyTrackerPage";

import FoodReviewComponent from "./components/foodReviewPage/FoodReviewComponent";
import FoodReviewPage from "./pages/FoodReviewPage";
import ReportPage1 from "./pages/ReportPage1";
import AdminDashboardController from "./pages/AdminDashboardController";

// creating all locaSstorage empty variable

//FOR APP VERSION Update file src/AppVersion.js

const router = createBrowserRouter([
  {
    path: "/login",
    element: <AuthForm />,
    action: authAction,
    loader: tokenLoader,
  },
  {
    path: "/",
    element: <RootLayout />,
    errorElement: <ErrorPage />,
    id: "root",
    loader: tokenLoader,
    children: [
      {
        index: true,
        element: <HomePage />,
        id: "home",
        loader: checkAuthLoader,
      },
      { path: "home", element: <HomePage /> },

      {
        path: "submitsuccess",
        element: <SubmitSuccess />,
      },
      {
        path: "qrcode",
        element: <FeedbackQRCode />,
      },
      {
        path: "/submitsuccesslink",
        element: <SubmitSuccessLink />,
      },
      {
        path: "myprofile",
        element: <MyProfilePage />,

        action: profileAction,
      },
      {
        path: "summary",
        element: <AiSummary />,
      },
      {
        path:"loyalty",
        element: <LoyaltyPage />,
      },
      {
        path: "loyaltytracker",
        element: <LoyaltyTrackerPage />,
      },

      {
        path: "createnewaccount",
        element: <SignupForm />,
        action: signupAction,
      },
      {
        path: "questiondetail",
        element: <QuestionDetail />,
      },
      {
        path: "savedFeedbacks",
        element: <SavedFeedbacks />,
      },
      {
        path: "staff",
        element: <StaffPage />,
      },
      {
        path: "food",
        element: <FoodReviewPage />,
      },
      {
        path: "report",
        element: <ReportPage1 />,
      },
      {
        path: "/admin-dashboard-controller",
        element: <AdminDashboardController />,
      },
      { path: "logout", action: logoutAction },
    ],
  },
]);

function App() {
  // console.log("app start");
  document.title = "commNsense";
  return <RouterProvider router={router} />;
}

export default App;
